module.exports = __webpack_public_path__ + "assets/img/62429eeb7b5c337a6f117356bdf744e1.png";